import React, { useState } from "react";
import styles from "./footerMenuLink.module.scss";
import { Link as NavLink, useLocation } from "react-router-dom";
import { Tooltip } from "antd";
import IconOutline from "src/assets/icons/new-outline-info.svg?react";
import { LordIcon } from "../../lord-icon/lord-icon";
import { IconNav } from "@constants";
import IconStatus from "../assets/ellipse.svg?url";

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  to?: string;
  iconUrl?: string;
  href?: string;
  target?: string;
  title?: string;
  statusDescription?: string;
  onClick?: (e?: any) => void;
  className?: string;
  comingSoon?: boolean;
  onMouseOver?: (e?: any) => void;
  onMouseLeave?: (e?: any) => void;
};

const colors = { primary: "#FFB073", secondary: "#6C969A" };

function FooterMenuLink({
  to,
  iconUrl,
  href,
  target,
  title,
  statusDescription,
  onClick,
  onMouseOver,
  onMouseLeave,
  className,
  comingSoon = false,
}: Props) {
  const { pathname } = useLocation();
  const [isHover, setIsHover] = useState(false);
  const active = pathname === to;

  return (
    <div className={styles.menuWrapper}>
      {!!href ? (
        <a
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${
            className || ""
          }`}
          href={href}
          target={target}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
        >
          {iconUrl && (
            <div className={styles.menuLeftIcon}>
              <LordIcon
                src={iconUrl}
                isHover={isHover}
                target=".ant-menu-submenu-title"
              />
            </div>
          )}
          {
            title && (
              <div className={styles.menuItemSubTitle}>{title}</div>
            )
          }
          {statusDescription && (
            <div className={styles.statusDescription}>
              <img src={IconStatus} alt="Status" />
              {statusDescription}
            </div>
          )}
          <LordIcon
            src={IconNav}
            isHover={isHover}
            colors={colors}
            size={14}
            mainColor="#6C959A"
          />
        </a>
      ) : !!to ? (
        <NavLink
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${
            className || ""
          }`}
          to={to || ""}
          onMouseOver={() => {
            setIsHover(true);
          }}
          onMouseLeave={() => {
            setIsHover(false);
          }}
        >
          {iconUrl && (
            <div className={styles.menuLeftIcon}>
              <LordIcon
                src={iconUrl}
                isHover={isHover}
                target=".ant-menu-submenu-title"
              />
            </div>
          )}
          <div className={styles.menuItemSubTitle}>{title}</div>
          {statusDescription && (
            <div className={styles.statusDescription}>
              <img src={IconStatus} alt="Status" />
              {statusDescription}
            </div>
          )}
          <LordIcon
            src={IconNav}
            isHover={isHover}
            colors={colors}
            mainColor="#6C959A"
            size={20}
          />
        </NavLink>
      ) : (
        <div
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${
            className || ""
          }`}
          onMouseOver={() => {
            setIsHover(true);
          }}
          onMouseLeave={() => {
            setIsHover(false);
          }}
          style={{ cursor: comingSoon ? "default" : "pointer" }}
        >
          <div className={styles.menuItemContent}>
            {iconUrl && (
              <div className={styles.menuLeftIcon}>
                <LordIcon
                  src={iconUrl}
                  isHover={isHover}
                  target=".ant-menu-submenu-title"
                />
              </div>
            )}
            <div className={styles.menuItemSubTitle}>{title}</div>
          </div>
          <LordIcon
            src={IconNav}
            isHover={isHover}
            size={20}
            colors={colors}
            mainColor="#6C959A"
          />
        </div>
      )}
    </div>
  );
}

export default FooterMenuLink;
